var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-box"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.txt))]),_c('Progress',{staticStyle:{"width":"80%"},attrs:{"percent":_vm.percent,"stroke-width":20,"text-inside":"","status":"active"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }